<template>
  <div>
    <h4 class="fs-18 text-bold">{{ $t('pages.company_details.header') }}</h4>
    <table>
      <tbody>
        <tr
          v-for="item in $t('pages.company_details.rows')"
          :key="item.header"
        >
          <th>{{ item.header }}</th>
          <td>{{ item.text }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CompanyDetails',
};
</script>

<style lang="scss" scoped>
table, th, td {
  border: 1px solid #ddd;
  border-collapse: collapse;
}

th, td {
  padding: 8px;
  text-align: left;
}
</style>
